import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import AppRoutes from "./router/Routes";
import ScrollToTop from "./router/ScrollToTop";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { CustomerProvider } from "./contexts/CustomerContext";
import { AddressProvider } from "./contexts/AddressContext";

const App: React.FC = () => {
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_API_KEY ?? "";

  if (googleMapsApiKey === "") {
    console.log("Google Maps API key is not set");
  }

  return (
    <Provider store={store}>
      <Router>
        <CustomerProvider>
          <AddressProvider googleMapsApiKey={googleMapsApiKey}>
            <Toaster position="top-right" />
            <ScrollToTop />
            <HelmetProvider>
              <AppRoutes />
            </HelmetProvider>
          </AddressProvider>
        </CustomerProvider>
      </Router>
    </Provider>
  );
};

export default App;
